import React, { ReactElement } from 'react'

import styles from './Button.module.scss'
import cn from 'classnames'

interface Props {
  tag?: 'link' | 'button'
  value: string
  onClick?: any
  className?: string
  disabled?: boolean
  testName?: string
  bg?: "accent" | "hollow"
  border?: "noBorder"
  uppercase?: boolean
  borderDiagonal?: 'left' | 'right'
  leftIcon?: ReactElement
  rightIcon?: ReactElement
  animationIcon?: 'right'
  url?: string
}
export default function Button({
  tag='button',
  url,
  value,
  onClick,
  className,
  disabled,
  testName,
  bg="accent",
  border,
  uppercase,
  borderDiagonal,
  leftIcon,
  rightIcon,
  animationIcon
}: Props) {
  return (
    tag === 'link' ?
        <a
          target='_blank'
          href={url}
          data-test-id={testName}
          className={cn(styles.Button, className, styles[bg], styles[border??''], styles[`border_diagonal_${borderDiagonal}`], uppercase && styles.uppercase, )}
        >
            {leftIcon && <span className={cn(styles.iconWrapper, styles[`animation_${animationIcon}`])}>{leftIcon}</span>}
            <span>{value}</span>
            {rightIcon && <span className={cn(styles.iconWrapper, styles[`animation_${animationIcon}`])}>{rightIcon}</span>}
        </a>
        :
    <button
      data-test-id={testName}
      onClick={onClick}
      className={cn(styles.Button, className, styles[bg], styles[border??''], styles[`border_diagonal_${borderDiagonal}`], uppercase && styles.uppercase, )}
      disabled={disabled}
    >
      {leftIcon && <span className={cn(styles.iconWrapper, styles[`animation_${animationIcon}`])}>{leftIcon}</span>}
            <span>{value}</span>
            {rightIcon && <span className={cn(styles.iconWrapper, styles[`animation_${animationIcon}`])}>{rightIcon}</span>}
    </button>
  )
}
